module.exports = __webpack_public_path__ + "static/media/eng.4df1e7ea.svg";